import { useFormState } from 'react-final-form';
import { EntityActions } from './EntityActions';
import type { EntityActionsProps } from './EntityActions';
import { ReactElement } from 'react';

export function EntityFormActions<T = any>({ disabled, ...props }: EntityActionsProps<T>): ReactElement {
  const { dirty } = useFormState({ subscription: { dirty: true } });
  return <EntityActions {...props} disabled={disabled || dirty} />;
}
